var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M399.131,512H57.489c-29.259,0-53.063-23.803-53.063-53.063V53.063C4.426,23.804,28.23,0,57.489,0 h397.02c29.259,0,53.065,23.804,53.065,53.063v362.028c0,8.148-6.608,14.756-14.756,14.756c-8.148,0-14.756-6.608-14.756-14.756 V53.063c0-12.987-10.565-23.552-23.553-23.552H57.489c-12.987,0-23.552,10.565-23.552,23.552v405.875 c0,12.987,10.565,23.552,23.553,23.552h341.64c8.148,0,14.756,6.608,14.756,14.756S407.279,512,399.131,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M275.612,218.474c0-0.677,0.226-1.58,0.453-2.485l42.017-137.798 c2.485-7.906,12.65-11.747,23.041-11.747s20.558,3.841,23.041,11.747l42.243,137.798c0.226,0.903,0.453,1.808,0.453,2.485 c0,8.358-12.877,14.458-22.591,14.458c-5.647,0-10.165-1.808-11.521-6.55l-7.68-28.238h-47.664l-7.68,28.238 c-1.356,4.744-5.873,6.55-11.521,6.55C288.489,232.932,275.612,226.832,275.612,218.474z M357.613,171.034l-16.49-60.54 l-16.491,60.54H357.613z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F4B2B0"
    },
    cx: 157.251,
    cy: 149.682,
    r: 52.103
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M157.25,216.554c-36.87,0-66.866-29.996-66.866-66.866c0-36.869,29.996-66.864,66.866-66.864 c36.869,0,66.864,29.996,66.864,66.864C224.114,186.559,194.119,216.554,157.25,216.554z M157.25,112.334 c-20.598,0-37.354,16.757-37.354,37.353c0,20.598,16.757,37.354,37.354,37.354c20.596,0,37.353-16.757,37.353-37.354 C194.603,129.091,177.846,112.334,157.25,112.334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M292.385,291.267c0-7.227,7.68-10.844,15.361-10.844h46.31c22.591,0,45.179,8.133,45.179,40.211 c0,18.297-7.227,30.27-19.202,35.465c13.78,5.195,23.268,13.555,23.268,36.143v4.744c0,35.691-19.879,48.569-45.405,48.569h-50.149 c-9.488,0-15.361-4.97-15.361-10.617V291.267H292.385z M327.4,342.546h23.718c8.585,0,12.877-7.906,12.877-15.587 c0-7.906-4.291-15.814-12.877-15.814H327.4V342.546z M349.99,414.833c11.294,0,18.071-6.326,18.071-20.783v-3.614 c0-15.361-6.777-20.782-18.071-20.782h-22.591v45.179H349.99z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F4B2B0"
    },
    cx: 160.808,
    cy: 362.992,
    r: 52.103
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M160.808,429.855c-36.87,0-66.866-29.996-66.866-66.864c0-36.87,29.996-66.866,66.866-66.866 c36.869,0,66.864,29.996,66.864,66.866C227.672,399.859,197.676,429.855,160.808,429.855z M160.808,325.636 c-20.598,0-37.354,16.757-37.354,37.354c0,20.596,16.757,37.353,37.354,37.353c20.596,0,37.353-16.757,37.353-37.353 C198.16,342.393,181.404,325.636,160.808,325.636z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTest);
export default __webpack_public_path__ + "static/media/test.6bddca98f5bbc6a12d4933380167ecd3.svg";
export { ForwardRef as ReactComponent };